import { render, staticRenderFns } from "./myInfoPool.vue?vue&type=template&id=70d9e978&scoped=true"
import script from "./myInfoPool.vue?vue&type=script&lang=js"
export * from "./myInfoPool.vue?vue&type=script&lang=js"
import style0 from "./myInfoPool.vue?vue&type=style&index=0&id=70d9e978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d9e978",
  null
  
)

export default component.exports